import React from 'react';
import { StyledInput } from './index.styled';
import { InputProps } from 'antd';

type AppInputProps = InputProps & {
  allowCapitalize?: boolean;
  upperCaseAll?: boolean;
};

// Text input only. Numeric fields use the purpose components instead:
// AppCurrencyInput (money), AppPercentageInput (%), AppRateInput (rates/counts).
const AppInput: React.FC<AppInputProps> = ({
  onChange,
  allowCapitalize = true,
  upperCaseAll = false,
  status,
  ...rest
}: AppInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (upperCaseAll || allowCapitalize) {
      const value = e.target.value;
      const transformedValue = upperCaseAll
        ? value.toUpperCase()
        : value.charAt(0).toUpperCase() + value.slice(1);

      // Create a new event with the capitalized value
      const newEvent = {
        ...e,
        target: {
          ...e.target,
          value: transformedValue,
        },
      };

      // Call the original onChange if provided
      if (onChange) {
        onChange(newEvent);
      }
      return;
    }

    if (onChange) {
      onChange(e);
    }
  };

  return <StyledInput {...rest} status={status} onChange={handleChange} />;
};
export default AppInput;
